import Terms from '../components/Terms.vue'
import { bootstrapPage } from '../bootstrapPage'

bootstrapPage(Terms)
